"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoRosterConfigureSchools = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _useCheckConfig2 = _interopRequireDefault(require("./useCheckConfig"));
var _s = _interopRequireDefault(require("./s.css"));
var _window, _window$cccisd;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = (_window = window) === null || _window === void 0 ? void 0 : (_window$cccisd = _window.cccisd) === null || _window$cccisd === void 0 ? void 0 : _window$cccisd.boilerplate;
var AutoRosterConfigureSchools = exports.AutoRosterConfigureSchools = function AutoRosterConfigureSchools(_ref) {
  var closeModal = _ref.closeModal,
    row = _ref.row,
    loadData = _ref.loadData;
  var _useCheckConfig = (0, _useCheckConfig2["default"])({
      groupId: row['group.groupId']
    }),
    gqlLoading = _useCheckConfig.gqlLoading,
    siteList = _useCheckConfig.siteList,
    initialValues = _useCheckConfig.initialValues;
  var _useState = (0, _react.useState)(initialValues),
    _useState2 = _slicedToArray(_useState, 2),
    currentValues = _useState2[0],
    setCurrentValues = _useState2[1];
  var handleSubmit = function handleSubmit(values, actions) {
    _cccisdAxios["default"].post(Boilerplate.route('api.autoroster.rosterMethod'), {
      rosterMethod: values
    }).then(function (res) {
      actions.resetForm(values);
      setCurrentValues(values);
      return res;
    })["catch"](function (res) {
      if (res.errors) (0, _cccisdNotification["default"])({
        type: 'danger',
        message: res.errors.map(function (e) {
          return e + '\n\n';
        })
      });
      return res;
    });
  };
  if (gqlLoading || siteList === null) return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: true,
    type: "inline"
  });
  if (!gqlLoading && siteList !== null && !siteList.length) return /*#__PURE__*/_react["default"].createElement("div", null, "No synced schools were found.");
  if (currentValues === null) {
    setCurrentValues(initialValues);
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: function onSubmit(values, actions) {
      return handleSubmit(values, actions);
    }
  }, function (_ref2) {
    var setFieldValue = _ref2.setFieldValue,
      setValues = _ref2.setValues,
      values = _ref2.values;
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: _s["default"].form
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _s["default"].row
    }, /*#__PURE__*/_react["default"].createElement("button", {
      disabled: !(0, _isEqual2["default"])(currentValues, values) ? false : true,
      className: "btn ".concat(!(0, _isEqual2["default"])(currentValues, values) ? 'btn-warning' : 'btn-default'),
      type: "submit"
    }, "Save Schools"), /*#__PURE__*/_react["default"].createElement("div", null, ' ', /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label",
      style: {
        marginRight: '0.5rem'
      }
    }, "Set all to:"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "btn-group"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return setValues(Object.keys(values).reduce(function (a, c) {
          return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(c), null));
        }, {}));
      }
    }, "Manual"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return setValues(Object.keys(values).reduce(function (a, c) {
          return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(c), 'class'));
        }, {}));
      }
    }, "Class"), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default",
      onClick: function onClick() {
        return setValues(Object.keys(values).reduce(function (a, c) {
          return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, "".concat(c), 'grade'));
        }, {}));
      }
    }, "Grade")))), /*#__PURE__*/_react["default"].createElement("hr", null), siteList.map(function (_ref3, i) {
      var group = _ref3.group,
        fields = _ref3.fields;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        key: "".concat(group.groupId),
        name: "".concat(group.groupId)
      }, function (_ref4) {
        var field = _ref4.field;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _s["default"].row,
          style: {
            alignItems: 'center',
            backgroundColor: i % 2 === 0 ? '#eee' : 'inherit'
          }
        }, /*#__PURE__*/_react["default"].createElement("strong", {
          style: {
            display: 'inline-block',
            width: '320px',
            wordBreak: 'break-word'
          }
        }, group.label), /*#__PURE__*/_react["default"].createElement("div", {
          className: "btn-group"
        }, /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn ".concat(!field.value ? 'btn-primary' : 'btn-default'),
          onClick: function onClick() {
            return setFieldValue("".concat(group.groupId), null);
          }
        }, "Manual"), /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn ".concat(field.value === 'class' ? 'btn-primary' : 'btn-default'),
          onClick: function onClick() {
            return setFieldValue("".concat(group.groupId), 'class');
          }
        }, "Class"), /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn ".concat(field.value === 'grade' ? 'btn-primary' : 'btn-default'),
          onClick: function onClick() {
            return setFieldValue("".concat(group.groupId), 'grade');
          }
        }, "Grade")));
      });
    })));
  });
};